// extracted by mini-css-extract-plugin
module.exports = {"Error":"styles_Error__Hws7d"};